import { any, func, node } from 'prop-types'
import { Component } from 'react'

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: any,
    errorComponent: node,
    handleError: func,
  }

  constructor(props) {
    super(props)
    this.state = { currentError: null }
  }

  static getDerivedStateFromError(error) {
    return { currentError: error }
  }

  componentDidCatch(error) {
    if (this.state.currentError && this.props.handleError) {
      this.props.handleError({ component: 'weekView', error })
    }
  }

  render() {
    if (this.state.currentError) {
      return this.props.errorComponent
    }
    return this.props.children
  }
}
